import React from 'react';
import {NeuroMessage, SurveyPagePropTypes} from '@ignitesales/neuro-application/src/neuro-guide';

const SurveyPage = ({ className, currentSurveyPage, renderQuestionGroups }) => {
  const pageKey = currentSurveyPage?.page?.key || '';
  const messageId = `sidebar.${pageKey}.message`;

  const renderSidebarMessage = () => {
    return <span class="text-inside"><NeuroMessage id={ messageId } shouldHideIfNotFound={true} /></span>;
  };

  return (
    <div className={className}>

      <div className="sidebar background">
        { renderSidebarMessage() }
      </div>

      <div className="component component--twoThird questionGroupComponent">

        { renderQuestionGroups() }

      </div>

    </div>
  );
};

SurveyPage.propTypes = SurveyPagePropTypes;

export default SurveyPage;
